/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PrimeDatatableParams } from '../../models/prime-datatable-params';
import { ServerStatusViewModelPrimeDatatableResults } from '../../models/server-status-view-model-prime-datatable-results';

export interface ListServerStatuses$Params {
      body?: PrimeDatatableParams
}

export function ListServerStatuses(http: HttpClient, rootUrl: string, params?: ListServerStatuses$Params, context?: HttpContext): Observable<StrictHttpResponse<ServerStatusViewModelPrimeDatatableResults>> {
  const rb = new RequestBuilder(rootUrl, ListServerStatuses.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ServerStatusViewModelPrimeDatatableResults>;
    })
  );
}

ListServerStatuses.PATH = '/api/Developer/ListServerStatuses';
